// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1N9h8","label":"Section_label__2_VxL","contentWrap":"Section_contentWrap__2AbnN","footer":"Section_footer__3zjWP","footerInner":"Section_footerInner__2-bRf"};